/* ==========================================================================
   Thunala - hai nut chuyen anh trong dialog phong to (trang san pham)

   Ella dung <dialog> chua ca danh sach anh roi cho cuon doc. Da co san cot
   thumbnail ben phai (base.css:6706) va vien cho anh dang xem, nhung KHONG co
   nut prev / next - khach chi chuyen anh bang cach cuon hoac bam thumbnail.

   File nay them hai nut do tu ngoai vao, KHONG sua blocks/_product-media-gallery.liquid.
   Ly do: file goc dai gan 800 dong va co ba nhanh render khac nhau theo
   `video_type` (inline / dialog / none) - chen markup vao ca ba nhanh la ba cho
   phai nho khi update theme. Chen bang JS thi chi mot cho.

   Cach cuon: KHONG tu tinh toa do roi scrollTo. Dung scrollIntoView cua chinh
   phan tu anh, de trinh duyet tu lo phan scroll-snap va smooth behavior ma
   Ella da khai. Tu tinh se lech ngay khi anh co ti le khac nhau (gallery nay
   dang de aspect_ratio: adapt).
   ========================================================================== */

(() => {
  const lockScroll = (on) => {
    if (on) document.documentElement.setAttribute('scroll-lock', '');
    else document.documentElement.removeAttribute('scroll-lock');
  };

  const ARROW = {
    prev: 'M15 4.5 7.5 12l7.5 7.5',
    next: 'M9 4.5 16.5 12 9 19.5',
  };

  function makeButton(direction, onActivate) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `etsy-zoom-nav etsy-zoom-nav--${direction}`;
    button.setAttribute('aria-label', direction === 'prev' ? 'Previous image' : 'Next image');
    button.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
      `<path d="${ARROW[direction]}" stroke="currentColor" stroke-width="2" ` +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';

    // ⚠️ stopPropagation la bat buoc: moi <li> anh trong dialog mang
    // onclick="…closeDialog()" (blocks/_product-media-gallery.liquid). Thieu dong
    // nay thi bam mui ten se DONG dialog thay vi chuyen anh.
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      onActivate();
    });

    return button;
  }

  function enhance(zoomDialog) {
    if (zoomDialog.dataset.etsyNav === 'true') return;

    const dialog = zoomDialog.querySelector('dialog');
    const gallery = zoomDialog.querySelector('.dialog-zoomed-gallery');
    if (!dialog || !gallery) return;

    const items = Array.from(gallery.children);
    if (items.length < 2) return; // mot anh thi khong can mui ten

    zoomDialog.dataset.etsyNav = 'true';

    // Anh nao dang o giua man hinh thi tinh la anh hien tai. Bam theo vi tri
    // cuon that chu khong giu mot bien dem - vi khach con cuon tay va bam
    // thumbnail, hai duong do khong di qua day.
    const currentIndex = () => {
      const middle = dialog.scrollTop + dialog.clientHeight / 2;
      let best = 0;
      let bestDistance = Infinity;

      items.forEach((item, index) => {
        const center = item.offsetTop + item.offsetHeight / 2;
        const distance = Math.abs(center - middle);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = index;
        }
      });

      return best;
    };

    const step = (delta) => {
      const next = Math.min(items.length - 1, Math.max(0, currentIndex() + delta));
      items[next].scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    dialog.append(
      makeButton('prev', () => step(-1)),
      makeButton('next', () => step(1))
    );

    // Mui ten trai/phai tren ban phim. Chi bat khi dialog dang mo that su -
    // <dialog> mo bang showModal() nen `dialog.open` la nguon dang tin.
    dialog.addEventListener('keydown', (event) => {
      if (!dialog.open) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        step(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        step(1);
      }
    });
  }

  /* ------------------------------------------------------------------------
     Khoa cuon trang nen khi dialog dang mo

     Ella co san co che: `html[scroll-lock] { overflow: hidden }` (base.css:99),
     va cart-drawer.js / age-verification-popup.js / before-you-leave.js deu
     `document.documentElement.setAttribute('scroll-lock', '')` khi mo.

     Rieng zoom-dialog thi KHONG. Markup co viet `<dialog scroll-lock>` nhung
     attribute nam tren chinh cai <dialog> - sai cho, khong rule CSS nao doc no.
     Ket qua: dialog mo ma trang nen van cuon duoc, nen tren dien thoai keo tay
     de xem vung anh phong to lai thanh cuon trang phia sau.

     Patch prototype thay vi sua zoom-dialog.js - update theme se ghi de file goc.
     ------------------------------------------------------------------------ */
  const patchScrollLock = () => {
    const ZoomDialog = customElements.get('zoom-dialog');
    if (!ZoomDialog || ZoomDialog.prototype.__etsyScrollLock) return false;

    const originalOpen = ZoomDialog.prototype.open;
    if (typeof originalOpen === 'function') {
      ZoomDialog.prototype.open = async function (...args) {
        const result = await originalOpen.apply(this, args);
        lockScroll(true);
        return result;
      };
    }

    const originalClose = ZoomDialog.prototype.closeDialog;
    if (typeof originalClose === 'function') {
      ZoomDialog.prototype.closeDialog = function (...args) {
        lockScroll(false);
        return originalClose.apply(this, args);
      };
    }

    ZoomDialog.prototype.__etsyScrollLock = true;
    return true;
  };

  // ⚠️ Gan rieng, KHONG gop vao enhance(): enhance() thoat som khi san pham chi
  // co 1 anh (khong can mui ten), ma khoa cuon thi anh nao cung can go.
  // Bam ESC lam <dialog> tu dong, KHONG di qua closeDialog() - thieu cho nay la
  // trang ket cung sau khi thoat bang phim.
  function watchClose(zoomDialog) {
    if (zoomDialog.dataset.etsyUnlock === 'true') return;
    const dialog = zoomDialog.querySelector('dialog');
    if (!dialog) return;

    zoomDialog.dataset.etsyUnlock = 'true';
    dialog.addEventListener('close', () => lockScroll(false));
  }


  /* ========================================================================
     DIEN THOAI: mo PhotoSwipe thay cho dialog cua Ella

     Ella boc anh trong <drag-zoom-wrapper> va co san CSS
     `transform: scale(var(--drag-zoom-scale))`, nhung KHONG co JS nao dinh nghia
     custom element do - da grep ca assets/ lan vendor.js. Bien `--drag-zoom-scale`
     khong bao gio duoc dat nen khai bao transform kia vo hieu. Tuc la tinh nang
     "keo de phong to trong anh" cua theme CHUA BAO GIO chay.

     Hau qua tren dien thoai: dialog chi la carousel ngang, khach phai pinch bang
     zoom cua TRINH DUYET va sau do chi vuot ngang duoc.

     Theme da co san PhotoSwipe (3 file trong assets/, Ella dung cho block
     Instagram). No lam dung thu can: cham de phong to, pinch muot, keo moi huong,
     vuot chuyen anh, vuot xuong de dong.

     ⚠️ CHI thay tren mobile. May tinh giu dialog cua Ella - o do da co cot
     thumbnail ben phai va hai nut mui ten minh them, dang chay tot.
     ======================================================================== */

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  let PhotoSwipeLightbox = null;
  let pswpLoading = false;
  let lightbox = null;

  async function loadPhotoSwipe() {
    if (PhotoSwipeLightbox) return PhotoSwipeLightbox;

    if (!document.getElementById('photoswipe-css')) {
      const link = document.createElement('link');
      link.id = 'photoswipe-css';
      link.rel = 'stylesheet';
      link.href = window.photoswipeUrls?.css || '/assets/lib-photoswipe.css';
      document.head.appendChild(link);
    }

    const module = await import(window.photoswipeUrls?.lightboxJs || '/assets/lib-photoswipe-lightbox.js');
    PhotoSwipeLightbox = module.default;
    return PhotoSwipeLightbox;
  }

  // Doc danh sach anh tu chinh gallery dang hien.
  // ⚠️ Loc `.swiper-slide-duplicate`: swiper dang bat `loop` nen no NHAN BAN slide,
  // ban sao copy nguyen `data-zoom-index` -> khong loc thi anh bi lap va so thu tu
  // nhay lung tung.
  function collectSlides(mediaColumn) {
    const slides = mediaColumn.querySelectorAll(
      '.swiper-main .swiper-slide[data-zoom-index]:not(.swiper-slide-duplicate)'
    );

    return Array.from(slides)
      .map((slide) => {
        const img = slide.querySelector('img');
        if (!img) return null;

        // `src` cua Ella da tro san ban lon nhat (width=3840), dung luon.
        const src = img.getAttribute('src') || img.currentSrc || img.src;
        if (!src) return null;

        // PhotoSwipe chi can TI LE dung de tinh muc phong. Lay ti le tu ban anh
        // dang hien roi quy ve mot canh 2048 - khong can biet kich thuoc goc.
        const ratio =
          img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight : 1;

        return {
          src: src.startsWith('//') ? window.location.protocol + src : src,
          width: 2048,
          height: Math.round(2048 / ratio),
          alt: img.getAttribute('alt') || '',
        };
      })
      .filter(Boolean);
  }

  async function openPhotoSwipe(mediaColumn, index) {
    const items = collectSlides(mediaColumn);
    if (!items.length) return false;

    await loadPhotoSwipe();

    if (lightbox) lightbox.destroy();

    lightbox = new PhotoSwipeLightbox({
      dataSource: items,
      pswpModule: () => import(window.photoswipeUrls?.coreJs || '/assets/lib-photoswipe.js'),
      initialZoomLevel: 'fit',
      secondaryZoomLevel: 2.5,
      maxZoomLevel: 4,
      wheelToZoom: true,
      bgOpacity: 1,
      padding: { top: 0, bottom: 0, left: 0, right: 0 },
    });

    lightbox.init();
    lightbox.loadAndOpen(Math.max(0, Math.min(index, items.length - 1)));
    return true;
  }

  /* ⚠️ Bat o pha CAPTURE (tham so thu ba = true) de chay TRUOC listener cua Ella.
     `stopPropagation()` o day chan luon viec Ella mo <dialog> - neu de bubble thi
     ca hai cung mo, PhotoSwipe nam tren dialog rong. */
  document.addEventListener(
    'click',
    (event) => {
      if (!isMobile()) return;

      const slide = event.target.closest('[data-zoom-index][data-zoom-target]');
      if (!slide) return;

      // ⚠️ Da tung tai hong o slide nay -> khong chan nua, de Ella mo dialog cua no.
      // Thieu co nay thi `slide.click()` ben duoi kich hoat lai chinh listener nay:
      // vong lap vo han.
      if (slide.dataset.etsyPswpFailed === 'true') return;

      const mediaColumn = slide.closest('.product-information__media');
      if (!mediaColumn) return;

      event.preventDefault();
      event.stopPropagation();

      openPhotoSwipe(mediaColumn, Number(slide.dataset.zoomIndex) || 0).catch((error) => {
        // Tai that bai thi tra lai hanh vi cu: mo dialog cua Ella.
        console.error('PhotoSwipe khong tai duoc, quay ve dialog cua theme', error);
        slide.dataset.etsyPswpFailed = 'true';
        slide.click();
      });
    },
    true
  );

  const run = () => {
    patchScrollLock();
    document.querySelectorAll('zoom-dialog').forEach((zoomDialog) => {
      watchClose(zoomDialog);
      enhance(zoomDialog);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  // Doi variant hoac Customizer ve lai section thi gallery duoc dung lai tu dau,
  // nut cu bi vut theo. Chay lai cho phan moi - `data-etsy-nav` chan lam trung.
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('variant:update', run);
})();
